// imports
import { post as performTask } from './lib/autoTask';
import { getNFTs as fetchNFTIds } from './lib/alchemy';
import { get as fetchAvailableSideQuests, action as questAction } from './lib/quests';
import { get as fetchConfig, getSideQuests as fetchSideQuestsConfig, IAPIQuests as IAPIQuestsRes } from './lib/config';
import {
  get as fetchPreferences,
  post as updatePreferences,
  Body as IUserPreferencesBody,
  Preferences as IUserPreferences
} from './lib/userPreferences';

// interfaces / types / consts
type IAPIQuests = IAPIQuestsRes;

// exports
export type { IAPIQuests, IUserPreferences, IUserPreferencesBody };
export const user = {
  fetchPreferences,
  updatePreferences
};
export const alchemy = { fetch: fetchNFTIds };
export const autoTask = { post: performTask };
export const config = { fetch: fetchConfig, fetchSideQuests: fetchSideQuestsConfig };
export const quests = { fetchAvailable: fetchAvailableSideQuests, action: questAction };
export default {
  user, config, quests, alchemy, autoTask
};
